import { Injectable } from '@angular/core';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
// import { BehaviorSubject } from 'rxjs';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/shared/AppSettings';
import { TranslateService } from '@ngx-translate/core';
import { ApiResultDialogService } from './ApiResultDialog.service';
import { MastersKeyStringValue } from './MastersKeyStringValue.service';
import { DisplayData } from 'src/app/models/non-master-model/DisplayData';
import { isNullOrUndefined } from 'util';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const TAG = 'ApiResultHandlerService';

@Injectable({
    providedIn: 'root'
})





export class ApiResultHandlerService {

    returnDisplayMsg: string;
    TAG = 'new-ApiResultHandlerService';

    displayData: DisplayData;



    constructor(private log: LoggerService,
                private translate: TranslateService,
                private apiResultDialogService: ApiResultDialogService,
                private router: Router,
                private modalService: NgbModal

               ) { }

    ResultHandler(returnData: any, pathFrom: string, pathTo: string) {

        this.displayData = new DisplayData;

        this.log.i(this.TAG, returnData.statusCode);
        this.log.i(this.TAG, returnData.custStatusCode);
        this.log.i(this.TAG, returnData.message);

        if (returnData.statusCode === StatusMessage.Status_OK) {

            this.SuccessHandler(returnData, pathFrom, pathTo);


        } else if (returnData.statusCode === StatusMessage.Status_BadRequest) {

            this.BadRequestHandler(returnData, pathFrom, pathTo);

        } else {

            this.translate.get('StatusCode_500').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        }


    }

    ResultHandlerWithDisplayDate(returnData: any, pathFrom: string, pathTo: string, displayData: DisplayData): number {

        this.displayData = new DisplayData;

        console.info(this.TAG + ':' + JSON.stringify(returnData));

        this.displayData = displayData;

        if (returnData.statusCode === StatusMessage.Status_OK) {

            this.SuccessHandler(returnData, pathFrom, pathTo);


        } else if (returnData.statusCode === StatusMessage.Status_BadRequest) {

            this.BadRequestHandler(returnData, pathFrom, pathTo);

        } else {
            if(pathFrom!=(AppSettings.Path_tMedicine + AppSettings.PATH_NEW)){
            this.translate.get('StatusCode_500').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });}else{
                this.returnDisplayMsg = "";
            }

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        }

        return 1;
    }


    openAPI_Result_Model(action, msg) {
        this.log.i(this.TAG, 'openConfirmModal action = ' + action);


        // if (!isNullOrUndefined(this.displayData.displayData1))
          if (this.displayData && this.displayData.displayData1)
          {
            if (this.displayData.displayData1 !== '') {
                msg += ' ' + this.displayData.displayData1 + ' ' + this.displayData.displayData2 + ' '
                + this.displayData.displayData3 + ' ' + this.displayData.displayData4 + ' ' + this.displayData.displayData5;
            }
        }



        this.apiResultDialogService.openDialog(action, '', status, msg);
    }

    openAPI_Result_Model_V2(action, msg) {
      this.log.i(this.TAG, 'openConfirmModalV2 action = ' + action);

      // if (!isNullOrUndefined(this.displayData.displayData1)) {
      //     if (this.displayData.displayData1 !== '') {
      //         msg += ' ' + this.displayData.displayData1 + ' ' + this.displayData.displayData2 + ' '
      //         + this.displayData.displayData3 + ' ' + this.displayData.displayData4 + ' ' + this.displayData.displayData5;
      //     }
      // }
      console.debug('msg : '+msg);
      console.debug('this.displayData : '+ JSON.stringify(this.displayData));

      this.apiResultDialogService.openDialogV2(action, '', msg, this.displayData);
    }

    ErrHandler()
    {
        this.translate.get('StatusCode_500').subscribe((res: string) => {
            this.returnDisplayMsg = res;
        });

        this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);
    }

    ErrHandlerWithMessage(message:string)
    {
        let messageData = new DisplayData();
        messageData.displayData1 = message;
        this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, messageData);
    }

    ErrHandlerWithDisplayData(displayData: DisplayData)
    {
        this.displayData = displayData;

        if (displayData.showDefaultMessage) {
          this.translate.get("StatusCode_500").subscribe((res: string) => {
            this.returnDisplayMsg = res;
          });
        }else{
          this.returnDisplayMsg = '';
        }

        this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);
    }

    BadRequestHandler(returnData: any, pathFrom: string, pathTo: string)
    {
        if (returnData.custStatusCode === StatusMessage.Status_tMedicine_Dup_mediCode) {

            this.translate.get('Message_DupMediCode').subscribe((res: string) => {
              this.returnDisplayMsg = res;
            });


            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_tMedicine_Dup_mediBarCode) {
            this.translate.get('Message_DupMediBarCode').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_Unauthorized) {
            this.translate.get('Message_ForceLogout').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            localStorage.removeItem('token');
            this.router.navigateByUrl('/login');

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_tMedicine_NotAllowInActive) {
            /*
            this.translate.get('Message_NotAllowInActive').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });*/
            this.returnDisplayMsg="";
            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_tMediConv_NotAllowEdit) {
            this.translate.get('Message_NotAllowEditMedicine').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_tMediCost_NotAllowEdit) {
            this.translate.get('Message_NotAllowEditMedicine').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_General_NotAllowInActive) {
            this.translate.get('Message_GNotAllowInActive').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_General_Dup_KeyCode) {
            this.translate.get('Message_GDupKeyCode').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        }else if (returnData.custStatusCode === StatusMessage.Status_General_Dup_KeyCode_HKID) {
            this.translate.get('Message_GDupKeyCodeHKID').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_General_NotAllowAdd) {
            this.translate.get('Message_GNotAllowAdd').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_General_NotAllowEdit) {
            this.translate.get('Message_GNotAllowEdit').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_General_NotAllowDel) {
            this.translate.get('Message_GNotAllowDel').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_General_InUse) {
            this.translate.get('Message_GInUse').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (returnData.custStatusCode === StatusMessage.Status_BillPay_PaymentFinished) {
            this.translate.get('Message_AlreadyPayment').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);
        }else if (returnData.custStatusCode === StatusMessage.Status_BillPay_PaymentChange) {
            this.translate.get('Message_AlreadyChanged').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);
        }

        else {
            this.ErrHandler();
        }

    }



    SuccessHandler(returnData: any, pathFrom: string, pathTo: string)
    {

        if (pathFrom ===  AppSettings.Path_tMedicine + AppSettings.PATH_NEW )
        {
            this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            localStorage.removeItem('systemMediCode');
            localStorage.setItem('systemMediCode', returnData.data.mediCode);

            localStorage.removeItem('systemMediCateCode');
            localStorage.setItem('systemMediCateCode', returnData.data.mediCateCode);


            this.router.navigate([pathTo]);
            //this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

            //TODO use new popup , can custom sentence color
            this.openAPI_Result_Model_V2(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);


        } else if (pathFrom ===  AppSettings.Path_tMedicine + AppSettings.PATH_EDIT ) {
            this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            // this.router.navigate([pathFrom]);
            this.router.navigate([pathTo]);
            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else if (pathFrom === AppSettings.Path_tConsultHead_Waiting) {
            // this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
            //     this.returnDisplayMsg = res;
            // });

            this.router.navigate([pathTo]);
            // this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);

        } else {
            this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
                this.returnDisplayMsg = res;
            });

            if (pathTo !== '')
            {
                this.router.navigate([pathTo]);
            }


            if (pathFrom === pathTo)
            {
                this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialogSucceed, this.returnDisplayMsg);
            } else {
                this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, this.returnDisplayMsg);
            }



        }
    }


    CheckApiResultDialogOpen(){
        return this.modalService.hasOpenModals();
    }

}
